import common from '../language/en/common.json'
import login from '../language/en/login.json'
import menu from '../language/en/menu.json'
import settings from '../language/en/settings.json'
import share from '../language/en/share.json'
import generalAdmin  from '../language/en/form.json'


export default {
    ...common,
    ...login,
    ...menu,
    ...settings,
    ...share,
    ...generalAdmin,

}



// WEBPACK FOOTER //
// ./src/wording/language/en.js